<script type="text/babel">
/**
 * @Module Analytics/Service
 * @description Analytics service holding helper methods
 * */
import { xlsExport } from '../../../vendor/xls/xls-export';

export default {
    name: 'AnalyticsService',
    /**
     * @function getProductQuantityFromCart
     * @param {Array} cart - order cart
     * @description Return total product quantity for given cart
     * */
    methods: {
        getProductQuantityFromCart (cart) {
            if(!this.validateObject(cart)) {
                return 0;
            } else {
                return cart.map(item => item.products
                    .map(product => product.quantity)
                    .reduce((a, b) => +a + +b, 0))
                    .reduce((a, b) => +a + +b, 0);
            }
        },
        /**
         * @function getCartPrice
         * @param {Array} cart - order cart
         * @param {Object} prices - prices object
         * @description Return total price for given cart
         * @returns {Number} cart total price
         * */
        getCartPrice (cart, prices) {
            if(!this.validateObject(cart)) {
                return 0;
            } else {
                return (cart.map(item => item.products.map(productItem => productItem.quantity * this.getProductPrice(productItem, prices))
                    .reduce((a, b) => a + b, 0))
                    .reduce((a, b) => a + b, 0));
            }
        },
        getProductPrice (productItem, prices) {
            if(productItem.priceObj) {
                return +productItem.priceObj.price;
            } else if(prices[productItem.id]) {
                return +prices[productItem.id].price;
            } else {
                return 1;
            }
        },
        /**
         * @function createDataSetArrayFromObject
         * @param {Array} obj - data object to create a dataset for
         * @param {String} prop - object property name = dataset name
         * @returns {Array} a dataset array
         * */
        createDataSetArrayFromObject (obj, prop) {
            let result = [];
            for (let key in obj) {
                prop && obj.hasOwnProperty(key) ? result.push(obj[key][prop]) : result.push(key);
            }
            return result;
        },
        /**
         * @function createDataSetArrayFromObject
         * @param {Object} data - data object to be converted
         * @returns {Array} a object as array
         * */
        createArrayFromObject (data) {
            let result = [];
            for (let key in data) {
                result.push(data[key]);
            }
            return result;
        },
        /**
         * @function fillDatasetGaps
         * @param {Object} dataset - dataset object
         * @param {Array} labels - existing labels in the dataset
         * @param {Array} chartLabels - full list of labels wanted in the dataset
         * @returns {Object} Returns a complete dataset
         * */
        fillDatasetGaps (dataset, labels, chartLabels) {
            let result = [];
            let i = 0;
            let j = 0;
            chartLabels.forEach(month =>  {
                if(!labels[month]) {
                    result.push(0);
                } else {
                    result[i] = dataset[j];
                    j++;
                }
                i++;
            });
            return result;
        },
        /**
         * @function validateObject
         * @param {Object} obj - object to be validated
         * @returns {Boolean} a boolean value of object validity
         * */
        validateObject (obj) {
            return obj && (Object.keys(obj).length !== 0);
        },
        /**
         * @function validateObject
         * @param {Object} data - XLS document data
         * @param {String} title - XLS doc title
         * @description Exports a given data object to xls file.
         * */
        exportObjectToCsv (data, title) {
            const xls = new xlsExport(this.createArrayFromObject(data), title);
            xls.exportToCSV(title + '.csv');
        }
    }
};

</script>
